import { createSelector } from '@ngrx/store';
import { cartPopupState } from '../root';

export const getCartPopupAnimation = createSelector(
    cartPopupState,
    cartPopup => cartPopup.animation,
);

